import {RouteRecordRaw} from "vue-router";
import SponsorsIndex from "@/modules/sponsoring/pages/Index.vue";

export const routes: RouteRecordRaw[] = [
  {
    path: '/sponsors',
    name: 'sponsors.index',
    component: SponsorsIndex,
  }
];